import React from 'react';
import { View, StyleSheet } from 'react-native';
import Typography from '../../typography/Typography';
import { ColorTokens, TypographyTypeDLS } from '@voltmoney/schema';
const RowContent = ({ title, value }) => {
    return (React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' } },
        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: title, color: ColorTokens.Grey_Night }),
        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: value, color: ColorTokens.Grey_Night })));
};
const styles = StyleSheet.create({});
export default RowContent;
